/**
 * Created by karora on 13/03/17.
 */

export class IssueStatus {
  issue_status_id: number;
  issue_status_text: string;

  static Resolved = 3;
  static Escalated = 4;
  static ResolvedDuplicate = 5;
  static Deferred = 6;
  //  ('New'), ('Open'), ('Resolved'), ('Escalated'), ('Deferred')
}
